import { render, staticRenderFns } from "./smartLockerManagement.vue?vue&type=template&id=2440f800&scoped=true"
import script from "./smartLockerManagement.vue?vue&type=script&lang=js"
export * from "./smartLockerManagement.vue?vue&type=script&lang=js"
import style0 from "./smartLockerManagement.vue?vue&type=style&index=0&id=2440f800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440f800",
  null
  
)

export default component.exports